// @<COPYRIGHT>@
// ==================================================
// Copyright 2025.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

// @ts-nocheck

import { setLocale } from 'js/localeService';
import { fetchApplicationContext } from 'xcs-base-acc-client/src/descommon/src/js/interopUtils';
import { DesAccConstants } from '../constant/desAccConstants';
import { AppCtxComponent } from 'js/reactAppCtx';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

export class UtilityManager {
    /**
     * @param {HTMLElement} element - The custom element instance
     */
    constructor(element) {
        this.element = element;
    }

    performInitialRender(localeToUse) {
        if (localeToUse && localeToUse.length > 0) {
            setLocale(localeToUse);
        }
        window.setAfxLocale = setLocale;

        ReactDOM.render(
            <AppCtxComponent>{this.element.createReactElement()}</AppCtxComponent>,
            this.element
        );
        this.element._hasInitialLocaleBeenRendered = true; // Mark initial render as complete
    }

    manageLocale(locale) {

        if (locale) {
            // Case 1: Locale attribute is already present on the element
            this.performInitialRender(locale);
        } else {
            // Case 2: No locale attribute, fetch it asynchronously
            fetchApplicationContext()
                .then((response) => {
                    this.element.setAttribute(DesAccConstants.LOCALE, response.locale);
                    this.performInitialRender(response.locale); // Use the fetched locale for initial render
                })
                .catch((error) => {
                    console.error('Error fetching application context or setting locale:', error);
                    this.performInitialRender('en-US');
                });
        }
    }

}